<template>
  <md-chip :class="['status-chip', type]">
    <span class="status-text">
      {{ status.label }}
    </span>

    <!-- Mobile + Desktop friendly tooltip -->
    <md-tooltip md-direction="top">
      {{ status.label }}
    </md-tooltip>
  </md-chip>
</template>

<script>
export default {
  name: 'MdStatus',
  props: {
    status: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    type() {
      const name = this.status.name;

      const success = ['active','approved','completed','process_completed','payment_paid','paid'];
      const danger  = ['failed','cancelled','rejected','canceled'];
      const warning = ['pending','payment_unpaid','awaiting_approval','process_pending'];
      const info    = ['requested','withdrawn','assessment_required'];

      if (success.includes(name)) return 'st-success';
      if (danger.includes(name))  return 'st-danger';
      if (warning.includes(name)) return 'st-warning';
      if (info.includes(name))    return 'st-info';
      return 'st-plain';
    }
  }
};
</script>

<style scoped>
/* --------- YOUR ORIGINAL COLORS (UNCHANGED) --------- */
.st-plain,
.st-success,
.st-warning,
.st-info,
.st-danger {
  font-weight: 500;
  font-size: 14px;
}

.st-plain {
  background-color: #00000030 !important;
  color: #000 !important;
}

.st-success {
  background-color: #4caf5020 !important;
  color: #4caf50 !important;
}

.st-warning {
  background-color: #fc990e20 !important;
  color: #fc990e !important;
}

.st-danger {
  background-color: #f4433620 !important;
  color: #f44336 !important;
}

.st-info {
  background-color: #00b0ff20 !important;
  color: #1fbcd3 !important;
}

/* --------- CHIP LAYOUT --------- */
.status-chip.md-chip {
  height: auto !important;
  min-height: 21px;
  max-width: 220px;
  white-space: normal !important;
}

/* --------- 2 LINE TEXT ONLY --------- */
.status-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
       /* exactly 2 lines */
  overflow: hidden;

  white-space: normal;
  line-height: 1.4;
  text-align: center;
  font-weight: 400;          /* bold stays */
  padding: 5px 5px !important;
}
</style>
